import { TranslationService } from '../../../services/translation.service';

function ShowMoreButton({ ariaControls, onClick }: { ariaControls: string; onClick: () => void }) {
  return (
    <div className="d-flex justify-content-center">
      <button aria-controls={ariaControls} className="btn btn-tertiary btn-icon-right btn-icon-caret-down" onClick={onClick}>
        {TranslationService.get('common.showmore')}
      </button>
    </div>
  );
}
export default ShowMoreButton;
